<ng-container *transloco="let t; read 'home.calculator'" [formGroup]="formGroup">
  <psc-select
    [hidden]="!advanced"
    formControlName="supplier"
    [label]="t('supplier.title')"
    [infoText]="t('supplier.info')"
    [isDisabled]="supplierDisabled"
    [options]="supplierOptions"
    [loading]="loadingSuppliers"></psc-select>

</ng-container>
